module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.8560/images/social-block-link.svg"